module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/android-icon-48x48-243e0a752e08d2fd901e1fcac46bb009.png";